export enum ASSET_ACTIONS {
  RESET_ASSET_LIST = 'ASSET_ACTIONS.RESET_ACCOUNT_LIST',
  SET_ASSET_LIST = 'ASSET_ACTIONS.SET_ACCOUNT_LIST',
  SET_ERROR_STATE = 'ASSET_ACTIONS.SET_ERROR_STATE',
  SET_LOADING_STATE = 'ASSET_ACTIONS.SET_LOADING_STATE',
}
